module.exports = __webpack_public_path__ + "img/unlock-button-hovered.0fb45865.png";